module.exports = __webpack_public_path__ + "img/life-experience.85e901f0.png";